
app.pageparrainageController = app.pageparrainageController || {};
app.pageparrainageController.defaultAction = {
   
    /**
     * Initialisation de la fonction
     * @returns {undefined}
     */
    init : function () {
        this.voiture();
        this.switch();
        this.smouthScroll();
    },

    smouthScroll : function () {
        $('.blk-intro .btn').on('click', function (event) {
            event.preventDefault();

            var page = $(this).attr('href'); // Page cible
            var speed = 750; // Durée de l'animation (en ms)
            var top = Math.round($(page).offset().top - 100);

            $('html, body').animate({scrollTop: top}, speed); // Go

            return false;
        });
    },

    voiture : function () {
        var blk = $('.blk-etapes');
        var voiture = $('.voiture', blk);
        var route = $('.route', blk);
        var etapes = $('.etape', blk);

        $(document).scroll( function() {
            var voitureMin = Math.round(route.offset().top);
            var voitureMax = Math.round(route.offset().top + route.outerHeight());
            var middleWindow = Math.round($(window).scrollTop() + ($(window).height() / 2));
            var paddingTop = 120;
            var detectBorne = 100;

            if (window.matchMedia("(max-width: 768px)").matches) {
                paddingTop = 0;
                detectBorne = 0;
                voitureMax = Math.round(route.offset().top + route.outerHeight() - voiture.height());
            }

            if (middleWindow >= voitureMin && middleWindow <= voitureMax) {
                voiture.css('top', (middleWindow - voitureMin - paddingTop));

                etapes.each(function() {
                    if ($('.borne', this).offset().top <= (voiture.offset().top + voiture.height() + detectBorne)) {
                        $(this).css('opacity', 1);
                        $('.blk-detail', this).css('transform', 'translate(0, 0)');
                    }
                });
            }
        });
    },

    switch : function () {
        var blk = $('.blkFilleul');
        var toggle = $('.toggle', blk);
        var toggleText = $('.toggle-text', blk);
        var toggleFirst = $('.toggle-first', blk);
        var toggleSecond = $('.toggle-second', blk);
        var blkPhones = $('.blkPhones', blk);
        var blkEmails = $('.blkEmails', blk);
        var inputCheckSMS = $('#slideOne', blk);
        inputCheckSMS.prop( "checked", false );

        toggleText.on('click', function() {

            if ($(this).hasClass('toggle-first')) {
                toggle.addClass('left');
                toggle.removeClass('right');

                toggleFirst.addClass('active');
                toggleSecond.removeClass('active');

                blkEmails.addClass('active');
                blkPhones.removeClass('active');

                inputCheckSMS.prop( "checked", false );
            } else {
                toggle.addClass('right');
                toggle.removeClass('left');

                toggleSecond.addClass('active');
                toggleFirst.removeClass('active');

                blkEmails.removeClass('active');
                blkPhones.addClass('active');

                inputCheckSMS.prop( "checked", true );
            }
        });

        var buttonAddField = $('.showField', blk);

        buttonAddField.on('click', function (e) {

            var dataFilleul = blk.data('filleul');

            if (dataFilleul < 11) {
                $('form .blkFilleul .blkEmails > p:nth-child('+ dataFilleul +'), form .blkFilleul .blkPhones > p:nth-child('+ dataFilleul +')').addClass('show');
                blk.data('filleul', dataFilleul + 1);
            }

            if (dataFilleul === 10) {
                buttonAddField.addClass('inactive');
            }
        });
    }
};

$(document).ready(function(){
    if($(".page-parrainage-js").length) {
        app.pageparrainageController.defaultAction.init();
    }
});
